/**
 * React Query wrapper for run table data.
 */

import { useQuery } from "@tanstack/react-query";
import { fetchRunTable } from "../api/runTable";

export function useRunTable(projectId: string, branch = "main") {
  return useQuery({
    queryKey: ["run-table", projectId, branch],
    queryFn: () => fetchRunTable(projectId, branch),
    refetchInterval: 15_000,
  });
}
